export const pushDataToAnalytics = (data: object) => {
  // @ts-ignore
  if (window.dataLayer !== undefined) {
    // @ts-ignore
    window.dataLayer.push({ ...data })
  }
}
